'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateIn = {
  from: {
    transformOrigin: 'center',
    transform: (0, _utils.rotate3d)(0, 0, 1, -200),
    opacity: 0
  },
  to: {
    transformOrigin: 'center',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateIn;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-in.js
// module id = 247
// module chunks = 54990529738226 257444579329143